import { render, staticRenderFns } from "./k-item.vue?vue&type=template&id=857b3456&lang=pug&"
import script from "./k-item.vue?vue&type=script&lang=js&"
export * from "./k-item.vue?vue&type=script&lang=js&"
import style0 from "./k-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('857b3456')) {
      api.createRecord('857b3456', component.options)
    } else {
      api.reload('857b3456', component.options)
    }
    module.hot.accept("./k-item.vue?vue&type=template&id=857b3456&lang=pug&", function () {
      api.rerender('857b3456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-item.vue"
export default component.exports